import { useEffect, useState } from "react";

/**
 * `true` for `delayMs`, then `false` forever — this app has no real backend,
 * so nothing actually "loads", but every content section should still show
 * a believable initial skeleton state rather than snapping straight to its
 * final content on mount (which reads as fake/instant in a way a real data
 * fetch never is). Pair with skeleton placeholders (`<SkeletonRow>` for
 * tables, `<SkeletonBlock>` for everything else) shown while this is true.
 */
export function useSimulatedLoad(delayMs = 500): boolean {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), delayMs);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isLoading;
}
